import { Injectable, inject } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { phoneNumberValidator } from '../../validators/phone-number-validator';
import { DetailedOrganizationFormGroup, SocialUrlsFormGroup } from './detailed-organization-form-group.interface';

@Injectable()
export class DetailedOrganizationFormModel {
  readonly fieldNames = {
    title: 'title',
    email: 'email',
    phoneNumber: 'phoneNumber',
    responsibleUserId: 'responsibleUserId',
    type: 'type',
    country: 'country',
    city: 'city',
    address: 'address',
    postalCode: 'postalCode',
    websiteUrl: 'websiteUrl',
    instagramSegment: 'instagramSegment',
    facebookSegment: 'facebookSegment',
    linkedInSegment: 'linkedInSegment'
  };

  form: FormGroup<DetailedOrganizationFormGroup>;

  constructor() {
    const formBuilder = inject(FormBuilder);

    this.form = formBuilder.group<DetailedOrganizationFormGroup>({
      title: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(128)],
      }),
      type: new FormControl(null, Validators.maxLength(128)),
      phoneNumber: new FormControl(null, phoneNumberValidator),
      email: new FormControl(null, [Validators.email]),
      responsibleUserId: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required],
      }),
      websiteUrl: new FormControl(null, Validators.maxLength(128)),
      country: new FormControl(null, Validators.maxLength(128)),
      city: new FormControl(null, Validators.maxLength(128)),
      address: new FormControl(null, Validators.maxLength(256)),
      postalCode: new FormControl(null, Validators.min(0)),
      social: new FormGroup<SocialUrlsFormGroup>({
        instagramSegment: new FormControl(null, Validators.maxLength(128)),
        facebookSegment: new FormControl(null, Validators.maxLength(128)),
        linkedInSegment: new FormControl(null, Validators.maxLength(128)),
      }),
    });
  }
}
